function isApiDisabled() {
    const api_disabled: string|undefined = process.env.REACT_APP_API_DISABLED;
    const isApiDiabled: boolean = api_disabled !== undefined && parseInt(api_disabled) === 1;
    return isApiDiabled && process.env.NODE_ENV !== 'production';
}

export default isApiDisabled;
